import { useMemo } from 'react';
import notificationTypes from '../../constants/notificationTypes';
import { useEventNotifications } from './useEventNotifications';
import { isMeetingNotification } from '../../filters/notifications/isMeetingNotification';

export function useMeetingsNotifications(eventId) {
    const notifications = useEventNotifications(eventId, {
        filter: isMeetingNotification,
    });
    return useMemo(
        () =>
            notifications.filter(
                (notif) =>
                    [
                        notificationTypes.MEETING_INVITE,
                        notificationTypes.MEETING_CONFIRM_OR_REJECT,
                    ].includes(notif.content?.data?.type) &&
                    !notif.content?.data?.target
            ),
        [notifications]
    );
}
